<template>
  <div>
    <LoadingSpinner v-if="!loading" />
    <div v-else>
      <div
        class="col-12 col-md-12 my-2"
        v-if="hasPermissions('superAdmin')"
      >
        <h5>Back-up</h5>
        <div class="form-group col-12 col-md-6 p-0 mb-2">
          <select v-model="selectedBackupId" class="form-control">
            <option value="">—</option>
            <option
              v-for="candidate in candidates"
              :key="candidate.id"
              :value="candidate.id"
            >
              {{ backupOptionLabel(candidate) }}
            </option>
          </select>
          <small v-if="isSelectedBackupInactive" class="text-danger d-block mt-1">
            This back-up is inactive
          </small>
        </div>
        <div class="col-md-12 p-0 mb-3">
          <button
            @click="saveBackup()"
            class="btn btn-primary w-25 font-weight-bold rounded-pill"
            :disabled="savingBackup"
          >
            {{ $t("lang.button.update") }}
          </button>
        </div>
      </div>

      <hr v-if="hasPermissions('superAdmin')" />

      <div
        class="col-12 col-md-12 my-2"
        v-if="hasPermissions('superAdmin')"
      >
        <h5>Non working days</h5>
        <div class="col-12 col-md-12 mb-4 p-0" style="margin-bottom: 310px">
          <date-picker
            id="startDatePicker"
            class=""
            v-model="filterMonth"
            :config="datePickerConfigNonWorkingDays"
            placeholder="Start Date"
          ></date-picker>
        </div>

        <div class="col-12 col-md-12 p-0">
          <multi-date-calendar
            v-model="daysNonWorking"
            :month="dateNonWorking.month"
            :year="dateNonWorking.year"
            :key="keyCalendar"
          >
          </multi-date-calendar>
        </div>
      </div>
      <div class="col-md-12" v-if="hasPermissions('superAdmin')">
        <button
          @click="saveNonWorkingDays()"
          class="btn btn-primary w-25 font-weight-bold rounded-pill"
        >
          {{ $t("lang.button.update") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MultiDateCalendar from "@/components/Common/MultipleDateCalendar.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { usersService } from "@/_services";
import moment from "moment";

export default {
  components: {
    MultiDateCalendar,
    LoadingSpinner,
  },
  props: {
    selectedUserId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      savingBackup: false,
      candidates: [],
      selectedBackupId: "",
      datePickerConfigNonWorkingDays: {
        format: "YYYY-MMM",
        viewMode: "months",
        minDate: moment().subtract(12, "month"),
        maxDate: moment().add(4, "month").endOf("month"),
      },
      filterMonth: moment().format("YYYY-MMM"),
      keyCalendar: 1,
      dateNonWorking: {
        month: moment().month(),
        year: moment().year(),
      },
      daysNonWorking: [],
    };
  },
  computed: {
    isSelectedBackupInactive() {
      if (!this.selectedBackupId) return false;
      const selected = this.candidates.find(
        (el) => String(el.id) === String(this.selectedBackupId)
      );
      return (
        selected &&
        selected.user_status_id !== undefined &&
        selected.user_status_id !== null &&
        parseInt(selected.user_status_id, 10) !== 1
      );
    },
  },
  watch: {
    filterMonth(newValue) {
      this.dateNonWorking.month = moment(newValue).month();
      this.dateNonWorking.year = moment(newValue).year();
      this.getDayByMonth(
        `${this.dateNonWorking.year}-${moment(newValue).format("MM")}`
      );
      this.keyCalendar++;
    },
  },
  created() {
    this.loadInitialData();
  },
  mounted() {
    this.keyCalendar++;
  },
  methods: {
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    backupOptionLabel(candidate) {
      const label = `${candidate.name} ${candidate.lastname} — ${candidate.email}`;
      if (
        candidate.user_status_id !== undefined &&
        candidate.user_status_id !== null &&
        parseInt(candidate.user_status_id, 10) !== 1
      ) {
        return `${label} (inactive)`;
      }
      return label;
    },
    loadInitialData() {
      this.loading = false;
      const yearMonth = `${this.dateNonWorking.year}-${moment(this.filterMonth).format("MM")}`;

      Promise.all([
        usersService.getBackupCandidates(this.selectedUserId),
        usersService.getBackup(this.selectedUserId),
        usersService.getNonWorkingDays(yearMonth, this.selectedUserId),
      ])
        .then(([candidatesRes, backupRes, daysRes]) => {
          const candidates =
            candidatesRes && candidatesRes.result ? candidatesRes.result : [];
          const backup = backupRes && backupRes.result ? backupRes.result : null;

          this.candidates = candidates;
          this.selectedBackupId = "";

          if (backup) {
            const inList = this.candidates.find(
              (el) => String(el.id) === String(backup.id)
            );
            if (!inList) {
              this.candidates = [backup, ...this.candidates];
            }
            this.selectedBackupId = backup.id;
          }

          this.daysNonWorking = daysRes || [];
          this.loading = true;
          this.keyCalendar++;
        })
        .catch((err) => {
          console.log(err);
          this.loading = true;
        });
    },
    getDayByMonth(yearMonth) {
      usersService
        .getNonWorkingDays(yearMonth, this.selectedUserId)
        .then((res) => {
          this.daysNonWorking = res;
          this.keyCalendar++;
        })
        .catch((err) => console.log(err));
    },
    saveBackup() {
      this.savingBackup = true;
      const backupUserId = this.selectedBackupId ? this.selectedBackupId : null;
      usersService
        .updateBackup(this.selectedUserId, backupUserId)
        .then(() => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            text: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 5000,
          });
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.savingBackup = false;
        });
    },
    saveNonWorkingDays() {
      const yearMonth = moment(this.filterMonth).format("YYYY-MM");
      const days_non_working = {
        yearMonth: yearMonth,
        days: Array.isArray(this.daysNonWorking)
          ? this.daysNonWorking.filter((el) => el.substr(0, 7) === yearMonth)
          : [],
      };
      usersService
        .updateNonWorkingDays(this.selectedUserId, days_non_working)
        .then(() => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            text: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 5000,
          });
        })
        .then(() => {
          this.filterMonth = moment().format("YYYY-MMM");
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
